module.exports = __webpack_public_path__ + "static/media/whatsapp_guide_desktop_06.b058495e.svg";